export default __webpack_public_path__ + "static/media/040-sailor.59662488.svg";